import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

export function Eyebrow({ children, className }: EyebrowProps) {
  return (
    <div className={cn('text-[13px] tracking-[0.12em] uppercase text-olive mb-3.5', className)}>
      {children}
    </div>
  );
}

interface SectionHeadingProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  align?: 'left' | 'center';
  action?: ReactNode;
  size?: 'md' | 'lg';
  light?: boolean;
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
  size = 'md',
  light = false,
  className,
}: SectionHeadingProps) {
  const titleSize = size === 'lg' ? 'text-[32px]' : 'text-[26px] md:text-[28px]';
  const titleColor = light ? 'text-paper' : 'text-ink';
  const descColor = light ? 'text-dark-muted' : 'text-muted';

  const content = (
    <div className={align === 'center' ? 'mx-auto max-w-xl text-center' : undefined}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className={cn('font-serif font-medium m-0', titleSize, titleColor)}>{title}</h2>
      {description && <p className={cn('text-[15.5px] leading-relaxed mt-3.5 mb-0', descColor)}>{description}</p>}
    </div>
  );

  if (!action) {
    return <div className={className}>{content}</div>;
  }

  return (
    <div className={cn('flex justify-between items-end flex-wrap gap-4', className)}>
      {content}
      {action}
    </div>
  );
}
